import type { ReactNode } from 'react';
import Navbar from '@components/navigation/Navbar';
import Footer from '@components/navigation/Footer';
import FloatingCTA from '@components/navigation/FloatingCTA';

interface RootLayoutProps { children: ReactNode; }

export default function RootLayout({ children }: RootLayoutProps) {
  return (
    <div className="min-h-screen bg-bg-primary flex flex-col">
      <Navbar />
      <main className="flex-1">
        {children}
      </main>
      <Footer />
      <FloatingCTA />
    </div>
  );
}